module.exports = __webpack_public_path__ + "static/media/demobg.e8bd0405.png";